module.exports = require("@gauzy/plugin-soundshot");